// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import { faMobileButton, faTabletButton } from 'lib-icons'

import { useTranslation } from '../localization'

import { Instructions } from './Instructions'

export const InstallInstructions = React.memo(function InstallInstructions() {
  const i18n = useTranslation()
  return (
    <Instructions
      deviceIcons={[faMobileButton, faTabletButton]}
      device={i18n.pwa.install.device}
      steps={i18n.pwa.install.steps}
    />
  )
})
